import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'class-names';
import PropTypes from 'prop-types';

import { openCart, addItem } from '../../redux/cart/actions';
import IconArrowLeft from '../icons/IconArrowLeft';
import IconArrowRight from '../icons/IconArrowRight';
import IconChevronLeft from '../icons/IconChevronLeft';
import IconChevronRight from '../icons/IconChevronRight';
import IconArrowRightV2 from '../icons/IconArrowRightV2';

class AddToCartButtonContent extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const {
      openCart,
      propertiesInputId,
      quantityInputId,
      addItem,
      quantity,
      items,
      variantInputId,
      measurements,
    } = this.props;
    e.preventDefault();

    const outOfStockNotifier = document.querySelector('.layout-pdp__out-of-stock-notify');
    const variantInput = document.getElementById(variantInputId);
    const propertiesInput = propertiesInputId && document.getElementById(propertiesInputId);
    const quantityInput = quantityInputId && document.getElementById(quantityInputId);
    const variantId = variantInput.value;
    const variant = items.find((node) => node.variantId === variantId);
    const newQuantity = (quantityInput && quantityInput.value) || quantity;
    let lineItemProps = null;

    if (variant.available) {
      openCart();

      if (propertiesInput && JSON.parse(propertiesInput.value)) {
        lineItemProps = JSON.parse(propertiesInput.value);
      }

      addItem(variantId, newQuantity, variant, lineItemProps, measurements);
    } else if (outOfStockNotifier) { outOfStockNotifier.style.display = 'block'; }
  }

  get leftIcon() {
    const { icon } = this.props;
    if (icon === 'arrow-left') {
      return (<IconArrowLeft />);
    } if (icon === 'chevron-left') {
      return (<IconChevronLeft />);
    }

    return '';
  }

  get leftIcon() {
    const { icon } = this.props;
    if (icon === 'arrow-left') {
      return <IconArrowLeft />;
    }
    if (icon === 'chevron-left') {
      return <IconChevronLeft />;
    }

    return '';
  }

  get rightIcon() {
    const { icon } = this.props;
    if (icon === 'arrow-right') {
      return <IconArrowRight />;
    }
    if (icon === 'chevron-right') {
      return <IconChevronRight />;
    }
    if (icon === 'arrow-right-v2') return <IconArrowRightV2 />;

    return '';
  }

  render() {
    const {
      isSmall, isTextOnly, label, icon, buttonClassMobile,
    } = this.props;
    const { leftIcon, rightIcon } = this;

    return (
      <div>
        <button
          onClick={this.handleClick}
          type="submit"
          className={classNames('button', {
            'button--small': isSmall,
            'button-text-only': isTextOnly,
            'button--has-icon': Boolean(icon),
            'button--small-mobile': buttonClassMobile,
          })}
          name="add"
        >
          {leftIcon}
          {' '}
          {label}
          {' '}
          {rightIcon}
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openCart,
  addItem,
};

AddToCartButtonContent.propTypes = {
  openCart: PropTypes.func.isRequired,
  propertiesInputId: PropTypes.string,
  quantityInputId: PropTypes.string,
  addItem: PropTypes.func.isRequired,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  variantInputId: PropTypes.string.isRequired,
  isSmall: PropTypes.bool,
  buttonClassMobile: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.string,
  measurements: PropTypes.objectOf(PropTypes.any),
};

AddToCartButtonContent.defaultProps = {
  propertiesInputId: null,
  quantityInputId: null,
  isSmall: false,
  buttonClassMobile: false,
  isTextOnly: false,
  quantity: null,
  label: 'Add to cart',
  icon: '',
  measurements: null,
};

export default connect(null, mapDispatchToProps)(AddToCartButtonContent);
